define('drops/dynamicBarcode/dynamicBarcode',[
    'jquery',
    'lq/drop',
    'lq/util',
    'lq'
], function ($, Drop, util, lq) {
    'use strict';

    var defaults = {
        data: {
            code: '12345678955'
        }
    };

    function DynamicBarcode(options) {
        Drop.call(this, $('<div />'), defaults, options);

        this.$element
            .addClass('boxToBorderSize')
            .css({
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%'
            });

        return this;
    };

    Drop.extend(DynamicBarcode, Drop);

    DynamicBarcode.typeName = 'DynamicBarcode';

    DynamicBarcode.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    DynamicBarcode.prototype.generate = function (url) {
        this.$element.css('background-image', 'url(' + url + ')');
    };

    DynamicBarcode.prototype.clearValue = function () {
        this.$image.empty();
    };

    DynamicBarcode.prototype.setValue = function (update) {
        var value = util.convertListOfKeyValuesToObject(update.value);

        if (!value) {
            this.clearValue();
        } else {
            this.data.code = value;
            this.generate(this.getImageUrl());
        }
    };

    DynamicBarcode.prototype.getImageUrl = function () {
        return lq.getTenantUrl('GeneratedContent/DynamicBarcode/'
            + '?actionId=' + this.rootDrop.data.id
            + '&barcodeId=' + this.data.id
            + '&code=' + this.data.code
            + '&barcodeType=' + this.data.barcodeType
            + '&width=' + this.data.size.x
            + '&height=' + this.data.size.y);
    };

    return DynamicBarcode;
});
